import React, { Component } from 'react';
import axios from 'axios'
import { serverIp } from '../../../../config/constants'
import { Form, Segment, Button, Divider, } from 'semantic-ui-react'
import Select from 'react-select';
import * as UiConsts from '../../../../config/UiConstants';
import { getPrintValues } from '../../newDashboard/algoliaDashboard/AlgoliaMiscUtils';

import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });

class UpdateItemStatus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            orderStatuses: [],
            status: ''
        }
    }

    componentDidMount(){
        console.log("++++++++:componentDidMount");
        getPrintValues("large_project_item_statuses", this.loadStatuses);
    }

    loadStatuses = (statuses) => {
        //  console.log("ddx12 ++++++ loadStatuses ");
        // console.log("ddx121 statuses:" + JSON.stringify(statuses, null, 3));
        this.setState({ orderStatuses: statuses })
    }

    updateReasonChange = (selected) => {
        console.log("++++++++: updateReasonChange");
        console.log(selected);
        //  console.log("selected json:"+JSON.stringify(selected));
        // console.log('gbv12 You\'ve sss:', value);
        // console.log("plus12:"+value.category);
        // console.log('gbv12 You\'ve selected:', value.value+" "+value.category);

        console.log("Selected: " + selected.value);

        let newState = {};
        newState['status'] = selected.value;
        console.log("newStatus:" + JSON.stringify(newState));

        //this.setState(newState);
        this.setState(newState);
    }

    updateStatus = () => {
        console.log("++++++++:updateStatus");
        console.log("this.props.projectId:" + this.props.projectId)
        console.log("this.props.user.email:" + this.props.user.email)
        console.log("dateNum:" + this.state.dateNum)

        if (!this.props.largeProjectItemId) {
            alert("No largeProjectItemId")
        } else if (!this.props.user.email) {
            alert("No Entered By Provided")
        } else if (this.state.status == '') {
            alert("No Status Selected")
        } else {
            console.log("sending data..");

            this.setState({ loading: true });

            axios.post(serverIp + "large_project_items/updateLargeProjectItemStatus", {
                apiKey: "asdf$#dfa",
                largeProjectItemId: this.props.largeProjectItemId,
                enteredBy: this.props.user.email,
                largeProjectItemStatus: this.state.status
            })
                .then((response) => {
                    this.setState({ loading: false })
                    console.log(response.data);

                    if (response.data.result) {
                        console.log("true.. adding project");
                        this.props.refresh();
                        alert(response.data.message);

                    } else {
                        console.log("FAILED");

                        alert(response.data.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({
                        loading: false
                    })
                });
        }
    }


    render() {

        const setStatusButton = this.state.status != ''
            ? <Button onClick={this.updateStatus}>UPDATE STATUS</Button>
            : ''

        const enterPaymentDate =
            <div>
                <Divider horizontal>{'UPDATE STATUS'}</Divider>

                <Form size='large' onSubmit={this.markProjectPaid}>
                    <Segment stacked>
                       {/* UPDATE REASON SELECT */}
                    <Select
                        value={this.state.status}
                        options={this.state.orderStatuses}
                        onChange={this.updateReasonChange}
                        searchable={false}
                        clearable={false}
                    />
                    {setStatusButton}
                    <br/>
                    </Segment>
                </Form>
            </div>


        return (this.state.loading ? <UiConsts.LoadingComponent /> : <div>
            {enterPaymentDate}

        </div>);
    }
}

export default UpdateItemStatus;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjectOrderEntry/UpdateItemStatus.js